import { useQuery } from "@tanstack/react-query";
import { glencocoPublicAPI } from "@/api/glencoco";
import { TIME_INTERVALS } from "shared/lib/constants/time";
import { QUERY_KEY_APP_VERSION } from "./constants";

export const useGetAppVersion = () => {
  const publicAPI = glencocoPublicAPI();

  return useQuery({
    queryKey: [QUERY_KEY_APP_VERSION],
    queryFn: async () => publicAPI.getAppVersion(),
    select: (response) => response?.data?.version,

    refetchInterval: TIME_INTERVALS.ONE_MINUTE,
    refetchIntervalInBackground: true,
  });
};
